export default __webpack_public_path__ + "static/media/times.81560eea.ttf";